// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // Make sure this imports Tailwind
import App from './App';
import './App.css';    // Your existing styles

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);